export function useDataExport() {
  const exportToCSV = (data, columns, filename) => {
    if (!data || data.length === 0) {
      console.warn('내보낼 데이터가 없습니다.')
      return
    }

    // 헤더 생성
    const headers = columns.map(col => col.title || col.key)
    
    // 데이터 행 생성
    const rows = data.map(item => {
      return columns.map(col => {
        const value = getNestedValue(item, col.key)
        
        // 포맷터가 있으면 적용
        if (col.formatter && typeof col.formatter === 'function') {
          return col.formatter(value, item)
        }
        
        // CSV를 위한 기본 처리
        if (typeof value === 'string' && value.includes(',')) {
          return `"${value}"`
        }
        
        return value || ''
      })
    })

    // CSV 콘텐츠 생성
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n')

    // 파일 다운로드
    downloadFile(csvContent, filename || `export-${new Date().toISOString().split('T')[0]}.csv`, 'text/csv')
  }

  const downloadFile = (content, filename, mimeType) => {
    const blob = new Blob([content], { type: `${mimeType};charset=utf-8;` })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = filename
    link.click()
    
    // 메모리 정리
    setTimeout(() => URL.revokeObjectURL(link.href), 100)
  }

  const getNestedValue = (obj, path) => {
    return path.split('.').reduce((current, key) => current?.[key], obj)
  }

  return {
    exportToCSV,
    downloadFile
  }
}